@if (depositButtonData$ | async; as depositData) {
  <div
    class="actionbutton__wrapper"
    [ngClass]="{ 'mod-asset-detail': isAssetDetailPage() }">
    @for (button of getActionButtons(); track button) {
      @if (button !== 'send') {
        <button
          class="btn actionbutton"
          (click)="onActionClick(button)"
				[disabled]="
					button !== 'deposit' ? isActionButtonDisabled(button, tradable) : depositData.depositButtonDisabled
				"
          [ngClass]="{ assetdetailpage: isAssetDetailPage() }">
          @if (isGenericActionButton(button)) {
            <span
              class="actionbutton__inner"
              [ngClass]="{ 'mod-asset-detail': isAssetDetailPage() }"
					[bp-tooltip]="
						getTooltip(button)
							| translate
								: [
										stakeable?.stakedAmount > 0
											? stakeable.name
											: (amountForButton(button)
												| fiat_precision_symbol
													: {
															id: fiat?.getId(),
															currencies: [fiat]
													  })
								  ]
					"
              position="top">
              <span class="actionbutton__icon" [ngClass]="{ 'mod-asset-detail': isAssetDetailPage() }">
                <span class="actionbutton__icon__actual symbol-icon bpi__icon-{{ button }}"></span>
              </span>
              <span class="actionbutton__label">{{ "button_" + button | translate }}</span>
            </span>
          }
          @if (button === 'send') {
            <span
              class="actionbutton__inner"
					[bp-tooltip]="
						getTooltip(button)
							| translate
								: [
										amountForButton('send')
											| tradable_precision_symbol
												: {
														id: tradable?.getId(),
														ignorePrecision: true,
														txPrecision: true,
														currencies: [tradable]
												  }
								  ]
					"
            position="top">
            <span class="actionbutton__icon">
              <span class="actionbutton__icon__actual symbol-icon bpi__icon-send"></span>
            </span>
            <span class="actionbutton__label">{{ "button_send" | translate }}</span>
          </span>
        }
        @if (button === 'transfer' || button === 'deposit') {
          <span
            class="actionbutton__inner"
					[bp-tooltip]="
						button !== 'deposit'
							? getTooltip(button)
							: (depositData.depositTooltip | translate: [amountForButton(button)])
					"
            position="top">
            <span class="actionbutton__icon">
              <span
                class="actionbutton__icon__actual symbol-icon bpi__icon-send"
							[ngClass]="{
								'bpi__icon-send': button === 'transfer',
								'bpi__icon-qr qr-font': button === 'deposit'
							}"></span>
            </span>
            <span class="actionbutton__label">{{
              "button_" + button | translate: [tradable?.getSymbol()]
            }}</span>
          </span>
        }
      </button>
    } @else {
      <button
        class="btn actionbutton"
        (click)="onSendClick()"
        [disabled]="isSendButtonDisabled() | async"
        [class.assetsdetailpage]="isAssetDetailPage()">
        <span
          class="actionbutton__inner"
			[bp-tooltip]="
				getSendButtonTooltip()
					| async
					| translate
						: [
								amountForButton('send')
									| tradable_precision_symbol
										: {
												id: tradable?.getId(),
												ignorePrecision: true,
												txPrecision: true,
												currencies: [tradable]
										  }
						  ]
			"
        position="top">
        <span class="actionbutton__icon">
          <span class="actionbutton__icon__actual symbol-icon bpi__icon-send"></span>
        </span>
        <span class="actionbutton__label">{{ "button_send" | translate }}</span>
      </span>
    </button>
  }
}
@if (showMoreActions() || !depositData.hideDepositInMoreButtons) {
  <button
    [matMenuTriggerFor]="menu"
    class="btn actionbutton"
    [ngClass]="{ assetdetailpage: isAssetDetailPage(), 'show-red-dot': showRedDot$ | async }">
    <span class="actionbutton__inner" [ngClass]="{ 'mod-asset-detail': isAssetDetailPage() }">
      <span class="actionbutton__icon mod-gray" [ngClass]="{ 'mod-asset-detail': isAssetDetailPage() }">
        <span class="actionbutton__icon__actual symbol-icon bpi__icon-more-horizontal"></span>
      </span>
      <span class="actionbutton__label">{{ "button_more" | translate }}</span>
    </span>
  </button>
  <mat-menu #menu="matMenu">
    @for (action of buttonMoreActions; track action) {
      @if (action !== 'send') {
        @if (
          action === TooltipTradableAction.LIMIT_ORDER || TooltipTradableAction.LEVERAGE
          ? true
          : action !== 'deposit'
          ? !isActionButtonDisabled(action, tradable)
          : !depositData.depositTooltip
          ) {
          <button
            mat-menu-item
            [disabled]="isActionButtonDisabled(action, tradable)"
            (click)="onActionClick(action)"
            class="actionbutton__menu-more">
            <span class="actionbutton__more-item">
              {{ "button_" + action | translate: [tradable?.getSymbol()] }}
            </span>
          </button>
        }
      } @else {
        @if ((isSendButtonDisabled() | async) === false) {
          <button
            mat-menu-item
            (click)="onSendClick()"
            class="actionbutton__menu-more">
            <span class="actionbutton__more-item">
              {{ "button_send_fiat" | translate: [tradable?.getSymbol()] }}
            </span>
          </button>
        }
      }
    }
  </mat-menu>
}
</div>
}

